import React, { useContext, useEffect } from "react";

import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import AdminLayout from "../../../components/Admin/Layout/index.jsx";

import Faqs from "../../../components/Admin/FAQ/index.jsx";

const pathPrefix = "/admin/faq";

const AdminBlogPage = () => {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <AdminLayout title={"FAQ"}>
      <Routes>
        <Route path="/" element={<Faqs />} />
      </Routes>
    </AdminLayout>
  );
};

AdminBlogPage.propTypes = {};

export default AdminBlogPage;
